import { makeStyles, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import LeadsForm from '../forms/LeadsForm';
import styles from './RegisterLead.module.scss';

const RegisterLead = () => {
	return (
		<div className={styles.regiser_lead_wrapper}>
			<h1 className={styles.title}>Register</h1>
			<LeadsForm />
		</div>
	);
};

export default RegisterLead;
